"use client";

import { useRouter } from "@/i18n/navigation";
import type { ReactNode } from "react";
import { RouterProvider } from "react-aria-components";
import { HasNavigatedProvider } from "./HasNavigatedProvider";

// Configure the type of the `routerOptions` prop on all React Aria components.
// https://react-aria.adobe.com/frameworks
declare module "react-aria-components" {
  interface RouterConfig {
    routerOptions: NonNullable<Parameters<ReturnType<typeof useRouter>["push"]>[1]>;
  }
}

export function AppRouterProvider({ children }: { children: ReactNode }) {
  const router = useRouter();
  return (
    <RouterProvider navigate={router.push}>
      <HasNavigatedProvider>{children}</HasNavigatedProvider>
    </RouterProvider>
  );
}
